module.exports = __webpack_public_path__ + "img/ALCP-logo.95e27d2e.svg";